import React from 'react';
import { Link, useParams } from 'react-router-dom';
import CarouselBanner from './common/CarouselBanner';
import './GardenModuleDetail.css';

function GardenModuleDetail() {
  const { moduleId } = useParams();

  // 模块数据配置
  const moduleData = {
    exotic: {
      title: '奇花异卉馆',
      description: '奇花异卉馆外特殊，花型奇念、花色绚丽或气味与众不同的一类植物。山荷分园主于温室空间内的生境营造，其中展示全球较典型的珍奇植物450余种，食虫植物的捕蝇草、茅膏菜、瓶子草、火炬草，被誉为自然界的"新猎手"，可以不用土壤生长的凤梨；时形怪色多变的秋海棠属。',
      image: require('../assets/xlhy/x2.png'),
      stats: {
        plantCount: '450余种',
        area: '2000平方米',
        highlights: ['捕蝇草', '茅膏菜', '瓶子草', '火炬草', '凤梨', '秋海棠']
      }
    },
    rainforest: {
      title: '热带雨林馆',
      description: '热带雨林馆，共收集保育全球热带雨林植物1300余种，主要展示全球雨林典型植物，呈现形态万千的雨林景观，划分为榕主题、沙漠合、空中花园、花卉合、天科是长期植物热带雨林从6个主题展区，展示热带雨林从林的天际及附生现象，突出空中花园、独木成林、气生根、支柱根、板根等各样的"根"。',
      image: require('../assets/xlhy/x3.png'),
      stats: {
        plantCount: '1300余种',
        area: '3500平方米',
        highlights: ['空中花园', '独木成林', '气生根', '支柱根', '板根', '附生植物']
      }
    },
    desert: {
      title: '沙生植物馆',
      description: '沙生植物馆，共收集保育各类沙生植物400种。通过营造沙漠千旱气候，营造蜘蛛、岩层、砂质、砂质环境，以典型群落化方式展示来自非洲、美洲的沙生植物，以沙漠里的大树和花为主题，营造"都市绿洲"的沙漠森林和"花卉世界"，以沙漠植物领奇多变的形态，均匀各目的花朵、超强的生命力展现带有沙漠的气候和环境的印记。',
      image: require('../assets/xlhy/x4.png'),
      stats: {
        plantCount: '400种',
        area: '1800平方米',
        highlights: ['仙人掌', '龙舌兰', '沙漠玫瑰', '多肉植物', '芦荟', '金琥']
      }
    },
    specimen: {
      title: '标本馆',
      description: '标本馆总建筑面积为4100平方米，建筑形象巧妙地融合其功能特点，其外观设计来源于厂房保护的岩石。内部重点打造"绿色星球奇幻之旅"植物主题大型沉浸式互动科普园和科普影院等科普宣传区，利用VR（虚拟现实）、AR（增强现实）、MR（混合现实）等感官体验技术，让游客从"一粒种子"开始，探索植物的奥秘。',
      image: require('../assets/xlhy/x5.png'),
      stats: {
        plantCount: '10000余件',
        area: '4100平方米',
        highlights: ['VR体验', 'AR互动', 'MR技术', '科普影院', '数字标本', '互动展示']
      }
    },
    outdoor: {
      title: '室外专类园区',
      description: '五个专类园区由杜鹃、百草、珍稀、山茶、和绿球园构成（其中杜鹃、绿球具花最多，花色丰富等特点，是春季的时令性植物；百草、山茶主要展现古中医药、茶树等，按植物"在地文化，保育研究特色植物种；珍稀园主要作为亚热带同地理条件植物的科普、保育直观室外专类园区地保护各类植物600余种。',
      image: require('../assets/xlhy/x6.png'),
      stats: {
        plantCount: '600余种',
        area: '15000平方米',
        highlights: ['杜鹃园', '百草园', '珍稀园', '山茶园', '绿球园', '药用植物']
      }
    }
  };

  const currentModule = moduleData[moduleId];

  if (!currentModule) {
    return (
      <div className="module-not-found">
        <h2>模块未找到</h2>
        <Link to="/garden">返回杏林花园</Link>
      </div>
    );
  }

  return (
    <div className="garden-module-page">
      {/* Hero Section - 沿用杏林花园的Banner */}
      <CarouselBanner 
        categoryNameEn="XLHY"
        defaultTitle={currentModule.title}
        defaultSubtitle="探索植物世界的奇妙之旅"
        className="hero-section"
      />

      <div className="container">
        <div className="module-content">
          {/* 面包屑导航 */}
          <nav className="breadcrumb">
            <Link to="/">首页</Link>
            <span>/</span>
            <Link to="/garden">杏林花园</Link>
            <span>/</span>
            <span>{currentModule.title}</span>
          </nav>

          {/* 模块介绍 */}
          <section className="module-overview">
            <div className="overview-content">
              <div className="overview-text">
                <h2>{currentModule.title}</h2>
                <p>{currentModule.description}</p>
                
                {/* 统计信息 */}
                <div className="module-stats">
                  <div className="stat-item">
                    <span className="stat-label">植物种类</span>
                    <span className="stat-value">{currentModule.stats.plantCount}</span>
                  </div>
                  <div className="stat-item">
                    <span className="stat-label">占地面积</span>
                    <span className="stat-value">{currentModule.stats.area}</span>
                  </div>
                </div>

                {/* 特色亮点 */}
                <div className="module-highlights">
                  <h3>特色亮点</h3>
                  <div className="highlights-tags">
                    {currentModule.stats.highlights.map((highlight, index) => (
                      <span key={index} className="highlight-tag">{highlight}</span>
                    ))}
                  </div>
                </div>
              </div>

              <div className="overview-image">
                <img src={currentModule.image} alt={currentModule.title} />
              </div>
            </div>
          </section>

          {/* 参观信息 */}
          <section className="visit-info">
            <h2>参观信息</h2>
            <div className="info-grid">
              <div className="info-card">
                <div className="info-icon">🕒</div>
                <h3>开放时间</h3>
                <p>每日 9:00 - 17:00<br/>（16:30停止入场）</p>
              </div>
              <div className="info-card">
                <div className="info-icon">🎫</div>
                <h3>参观方式</h3>
                <p>免费参观<br/>建议提前预约导览</p>
              </div>
              <div className="info-card">
                <div className="info-icon">📍</div>
                <h3>位置指引</h3>
                <p>位于杏林花园内<br/>请参考园区地图</p>
              </div>
              <div className="info-card">
                <div className="info-icon">💡</div>
                <h3>温馨提示</h3>
                <p>请勿触摸植物<br/>保持安静参观</p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default GardenModuleDetail;
